import { supplierOperationsAPI } from 'api/supplier/supplierOperationsAPI'
import { useState } from 'react'

export default function useSupplierOperations() {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(false)

  const updateSupplierOperations = async (data: any) => {
    setIsLoading(true)
    setError(false)

    let resp
    try {
      resp = await supplierOperationsAPI.updateSupplierOperations(data)

      if (resp && resp.data?.error) {
        setError(true)
      }
    } catch (error) {
      setError(true)
      resp = error?.response
    }

    setIsLoading(false)

    return resp
  }

  const createSupplierOperations = async (data: any) => {
    setIsLoading(true)
    setError(false)

    let resp
    try {
      resp = await supplierOperationsAPI.createSupplierOperations(data)

      if (resp && resp.data?.error) {
        setError(true)
      }
    } catch (error) {
      setError(true)
      resp = error?.response
    }

    setIsLoading(false)

    return resp
  }

  return {
    updateSupplierOperations,
    createSupplierOperations,
    isLoading,
    error,
  }
}
